import { useState, useEffect } from "react";
import api from "../services/api";

const useClosingReasonSettings = () => {
  const [requireClosingReason, setRequireClosingReason] = useState(true);
  const [requireClosingReasonQueues, setRequireClosingReasonQueues] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    const fetchSettings = async () => {
      try {
        const { data } = await api.get("/settings");
        
        const closingReasonSetting = data.find(
          setting => setting.key === "requireClosingReason"
        );
        
        const closingReasonQueuesSetting = data.find(
          setting => setting.key === "requireClosingReasonQueues"
        );
        
        if (isMounted) {
            // Por padrão, o motivo da finalização é obrigatório se a configuração não existir
            setRequireClosingReason(
            closingReasonSetting ? closingReasonSetting.value === "enabled" : true
            );

            // Carregar os departamentos selecionados
            try {
            const parsedQueues = closingReasonQueuesSetting?.value 
                ? JSON.parse(closingReasonQueuesSetting.value) 
                : [];
            setRequireClosingReasonQueues(parsedQueues);
            } catch (e) {
            console.error("Erro ao parsear requireClosingReasonQueues:", e);
            setRequireClosingReasonQueues([]);
            }
        }
        
      } catch (error) {
        console.error("Erro ao buscar configurações:", error);
        if (isMounted) {
            // Em caso de erro, manter como obrigatório por segurança
            setRequireClosingReason(true);
            setRequireClosingReasonQueues([]);
        }
      } finally {
        if (isMounted) {
            setLoading(false);
        }
      }
    };

    fetchSettings();

    return () => {
      isMounted = false;
    };
  }, []);

  // Função para verificar se um ticket específico deve exigir motivo de finalização
  const shouldRequireClosingReason = (ticket) => {
    // Se a configuração global estiver desabilitada, não exigir motivo
    if (!requireClosingReason) {
      return false;
    }

    // Se a configuração global estiver habilitada (enabled), SEMPRE exigir motivo
    // independentemente dos departamentos configurados
    return true;
  };

  const hasClosingReasonsForTicket = async (ticket) => {
    try {
      const params = new URLSearchParams();

      if (ticket?.queueId) {
        params.append("queueId", ticket.queueId);
      }

      const url = `/closing-reasons/list${
        params.toString() ? `?${params.toString()}` : ""
      }`;

      const { data } = await api.get(url);
      return Array.isArray(data) && data.length > 0;
    } catch (error) {
      console.error("Erro ao verificar motivos de finalização:", error);
      return true;
    }
  };

  return { 
    requireClosingReason, 
    requireClosingReasonQueues,
    shouldRequireClosingReason,
    hasClosingReasonsForTicket,
    loading 
  };
};

export default useClosingReasonSettings;